import { render, staticRenderFns } from "./ExpedientesNewOrEdit.vue?vue&type=template&id=79f7e8bd&scoped=true&"
import script from "./ExpedientesNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./ExpedientesNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./ExpedientesNewOrEdit.vue?vue&type=style&index=0&id=79f7e8bd&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f7e8bd",
  null
  
)

export default component.exports